import { HttpApiError, HttpApiMiddleware } from "@effect/platform";
import { Context } from "effect";

/**
 * Parsed JSON payload from a verified Telnyx webhook request.
 * Handlers should decode this with their specific schema.
 */
export class TelnyxPayload extends Context.Tag("TelnyxPayload")<
  TelnyxPayload,
  unknown
>() {}

/**
 * Verifies Telnyx ED25519 signature, parses body, provides via TelnyxPayload.
 * Endpoints using this should NOT use .setPayload() - body parsing happens here.
 */
export class TelnyxVerification extends HttpApiMiddleware.Tag<TelnyxVerification>()(
  "TelnyxVerification",
  { failure: HttpApiError.Unauthorized, provides: TelnyxPayload },
) {}
